import { render, staticRenderFns } from "./PlantContratoForm.vue?vue&type=template&id=e5654e12"
import script from "./PlantContratoForm.vue?vue&type=script&lang=js"
export * from "./PlantContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports